import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ForumSearch from './ForumSearch';

export default function ForumFlowRoute(){

    return (
        <Routes>
            <Route index element={<Navigate to="search" replace />} />
            <Route path="search" element={<ForumSearch />} />
            <Route path="question" element={<ForumSearch />} />
            <Route path="answer" element={<ForumSearch />} />
            <Route path="answer/edit" element={<ForumSearch />} />
            {/* fallback */}
            <Route path="*" element={<Navigate to="search" replace />} />
        </Routes>
    );
}